import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useFormContext, useWatch } from 'react-hook-form';
import { usePortalMotion } from '../../../../hooks/portal/usePortalMotion';
import { useLocalTranslation } from '../../../../utils/i18nKit';
import { RevealView } from '../../common/motion';
import { resolveIntroBrokerName } from '../utils';
import IntroButton from './IntroButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroCtaSection = function IntroCtaSection(props) {
  var onLogin = props.onLogin,
      onGetAccess = props.onGetAccess;

  var _usePortalMotion = usePortalMotion(),
      motionEnabled = _usePortalMotion.motionEnabled;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;
  /**
   * watch
   */


  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var brokerName = useWatch({
    control: control,
    name: 'brokerName'
  });
  var ctaTitle = useWatch({
    control: control,
    name: 'ctaTitle'
  });
  var ctaSubtitle = useWatch({
    control: control,
    name: 'ctaSubtitle'
  });
  /**
   * methods
   */

  var loginAction = function loginAction() {
    onLogin === null || onLogin === void 0 ? void 0 : onLogin();
  };

  var getAccessAction = function getAccessAction() {
    onGetAccess === null || onGetAccess === void 0 ? void 0 : onGetAccess();
  };

  return /*#__PURE__*/_jsx(Box, {
    className: "w-full py-16 md:py-24",
    children: /*#__PURE__*/_jsx(RevealView, {
      children: /*#__PURE__*/_jsxs(Box, {
        className: "relative flex flex-col items-start space-y-8 overflow-hidden rounded-3xl bg-[#006DB0] p-8 md:flex-row md:items-center md:space-y-0 md:px-14 md:py-16",
        children: [motionEnabled && /*#__PURE__*/_jsx(motion.div, {
          className: "absolute -right-20 -top-20 h-[320px] w-[320px] rounded-full bg-white/15 blur-[100px]",
          animate: {
            scale: [1, 1.25, 1],
            opacity: [0.5, 0.9, 0.5]
          },
          transition: {
            duration: 7,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }), /*#__PURE__*/_jsxs(Box, {
          className: "relative flex flex-1 flex-col space-y-4",
          children: [/*#__PURE__*/_jsx(Typography, {
            component: "h2",
            className: "font-['Playfair_Display',serif] text-3xl font-black leading-tight text-white md:text-[38px]",
            children: ctaTitle
          }), /*#__PURE__*/_jsx(Typography, {
            className: "text-base font-medium leading-7 text-white md:text-lg",
            children: resolveIntroBrokerName(ctaSubtitle, brokerName)
          })]
        }), /*#__PURE__*/_jsx(Box, {
          className: "relative flex flex-shrink-0 flex-col space-y-3 md:flex-row md:space-x-4 md:space-y-0",
          children: /*#__PURE__*/_jsx(IntroButton, {
            variant: "ghostOutline",
            onClick: loginAction,
            children: $t('page:subBrokerPortal.log_into_portal')
          })
        })]
      })
    })
  });
};

export default IntroCtaSection;